import { ArrayMinSize, IsArray, IsDefined, IsString, IsUrl } from 'class-validator';

export class ExtractZReadDetailsBodyDto {
  @IsDefined()
  @IsUrl()
  url: string;

  @IsDefined()
  @IsArray()
  @ArrayMinSize(1)
  @IsString({ each: true })
  paymentMethods: string[];
}